export default "__VITE_ASSET__l4Y9tvPc__"